




























































































import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, watch, onBeforeUnmount} from "@vue/composition-api";
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import axios from 'axios';

// Store
import { Endpoints, Mutations } from '@/ts/store/Constants';
import { Actions } from '@/ts/store/modules/Channels/constants';

import ErrorResponse from '@/ts/ErrorResponse';

// Components
import BaseModal from '@/components/NEW-STRUCTURE/desktop/Admin/modals/BaseModal.vue';

export default defineComponent({
    components: {
        BaseModal,
        ValidationObserver,
        ValidationProvider,
    },
    props: [
        'isVisible',
        'projectId',
    ],
    setup(props, context) {
        const store = context.root.$store;
        const showModal = computed({
            get() {
                return props.isVisible;
            },
            set(newValue) {
                context.emit('onClose', newValue);            
            },
        });

        const channelName: Ref<string> = ref('');

        const channelDescription: Ref<string> = ref('');

        const privateChannel: Ref<boolean> = ref(false);

        const mandatoryChannel: Ref<boolean> = ref(false);

        const channelType:  Ref<string> = ref('project');

        const corporationId: ComputedRef<number> = computed(() => {
            return store.getters['Corporations/getCurrentCorporation'] ? store.getters['Corporations/getCurrentCorporation'].id : 0;
        });

        const onSubmit = async (e) => {
            //@ts-ignore
            const isValid = await context.refs.observer.validate();

            if(isValid) {
                console.log('valid data');
                const requestData = new FormData();

                if (channelName.value) { 
                    requestData.append('name', channelName.value); 
                }
                if (channelDescription.value) {
                    requestData.append('description', channelDescription.value);
                }
                if (mandatoryChannel.value) {
                    requestData.append('default', '1');
                } else {
                    requestData.append('default', '0');
                }
                if (channelType.value === 'project' && privateChannel.value) {
                    requestData.append('private', '1');
                } else {
                    requestData.append('private', '0');
                }
                if (channelType.value === 'project') {
                    requestData.append('project_id', props.projectId);
                }

                axios.post(Endpoints.Admin.Channels.CHANNELS, requestData)
                    .then(() => {
                        store.dispatch(Actions.FETCH_PPROJECT_CHANNEL_LIST, props.projectId);
                        close();
                    })
                     .catch((error) => {
                        if (error.response && error.response.data && error.response.data.errors) {
                            const errors = error.response.data.errors;
                            if (errors.name && errors.name.length > 0) {
                                /* eslint-disable no-eval */
                                // @ts-ignore
                                context.refs.nameProvider.applyResult({
                                    // @ts-ignore
                                    errors: [ context.root.$t('channels.validation.name-has-been-taken', 'The name has been taken') ],
                                    valid: false,
                                    failedRules: {},
                                });
                                return;
                            }
                        }

                        if (error.response) {
                            const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                            store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                        } else {
                            console.log(error);
                        }
                    });
            }

        }

        const clearForm = () => {
            channelName.value = '';
            channelDescription.value = '';
            privateChannel.value = false;
            mandatoryChannel.value = false;
        }

        const close = () => {
            context.emit('onClose');
            clearForm();
        }

        watch(() => channelType.value, (currentValue, oldValue) => {
            clearForm();
        });

        onBeforeUnmount(() => {
            clearForm();
            channelType.value === 'project';
        });


        return {
            channelName,
            corporationId,
            channelDescription,
            channelType,
            mandatoryChannel,
            onSubmit,
            privateChannel,
            showModal,
            close,
        };
    },
});
